import {
  required,
  between,
} from 'vuelidate/lib/validators';
import { LifeExpectancyInformationType } from 'sigma-mappings';
import lifeExpectancyFields from './lifeExpectancyFields';

export default (informationType, totalAssetLifeExpectancyInYears) => {
  if (informationType === LifeExpectancyInformationType.IN_YEARS) {
    return {
      windings: {
        $each: {
          $trackBy: 'windingId',
          inYears: {
            required,
            between: between(
              lifeExpectancyFields.inYears.minValue,
              lifeExpectancyFields.inYears
                .getMaxValue(totalAssetLifeExpectancyInYears),
            ),
          },
          inPercentage: {
            required: required(false),
          },
        },
      },
    };
  }

  return {
    windings: {
      $each: {
        inYears: {
          required: required(false),
        },
        inPercentage: {
          required,
          between: between(
            lifeExpectancyFields.inPercentage.minValue,
            lifeExpectancyFields.inPercentage
              .getMaxValue(),
          ),
        },
      },
    },
  };
};
